import React from "react";
import './DotWaveLoader.css';

const DotWaveLoader = () => {
  return (
    <div className="dot-wave-loader">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="wave-dot" />
      ))}
    </div>
  );
}

export default DotWaveLoader;
